<template>
    <div style="background: #f9f9f9">
        <!-- 顶部搜索 -->
        <div class="printBanner">
            <div style="height: 170px">
                <div class="container">
                    <el-row :gutter="30" style="padding-top: 50px" >
                        <el-col :span="12" :offset="6" class="bannerSearch" >
                            <el-input
                                size="large"
                                placeholder="请输入内容"
                                v-model="form.keyword"
                                class=""
                                @keyup.native.enter="search"
                            >
                                <el-button
                                    slot="append"
                                    icon="el-icon-search"
                                    type="primary"
                                    @click="search"
                                ></el-button>
                            </el-input>
                            <ul class="flex" style="font-size: 12px; color: #fff">
                                <li style="margin: 15px; margin-left: 0px; cursor: pointer" @click="searchByKeyword(items)" v-for="(items, index) in keywords">{{ items }}</li>
                            </ul>
                        </el-col>
                    </el-row>
                </div>
            </div>
        </div>
        <!-- 标题 -->
        <div class="desTitle flex">
            <span>当前位置：</span>
            <!-- <span style="color: #777">设计市场 > 找大师</span> -->
			<el-breadcrumb separator=">">
			  <el-breadcrumb-item :to="{ path: '/design' }">设计市场</el-breadcrumb-item>
			  <el-breadcrumb-item >全部设计师</el-breadcrumb-item>
			</el-breadcrumb>
        </div>
        <!-- 选择类型 -->
        <div class="desClass">
            <div class="desTopClass desCommentClass">
                <div class="typeName">分类：</div>
                <div>
                    <div class="print_screen_boxP">
                        <p
                            v-for="(items, index) in screenList"
                            :key="index"
                            @click="getPrintScreen(index)"
                            :class="printScreenIndex == index ? 'screen_text' : ''"
                        >
                            {{ items.name }}
                        </p>
                    </div>
                    <!-- <div
                        class="flex destoPone"
                        style="padding: 15px 15px 5px; background: rgb(241, 245, 254);width: 1000px;"
                        v-show="classShow"

                    >
                        <el-checkbox
                                :indeterminate="isIndeterminate"
                                v-model="checkAll"
                                @change="handleCheckAllChange"
                                style="margin-right: 20px"
                        >全选</el-checkbox
                        >
                        <div style="margin: 15px 0"></div>
                        <el-checkbox-group
                                v-model="checkedCities"
                                @change="handleCheckedCitiesChange"
                        >
                            <el-checkbox
                                    v-for="(city, index) in screenList[printScreenIndex]
                      .screenTwo"
                                    :label="city"
                                    :key="index"
                            >{{ city.names }}</el-checkbox
                            >
                        </el-checkbox-group>
                    </div> -->
                </div>
            </div>
            <div class="desBottomClass desCommentClass">
                <div class="typeName">地区：</div>
                <el-cascader
                    v-model="regionValue"
                    :options="regionOptions"
                    placeholder="省/市/区"
                    clearable
                    @change="handleChange"
                    size="medium"
                    style="width: 334px"
                ></el-cascader>
                <!-- <el-button type="text" class="resetBtn" @click="reset">
                    <i class="el-icon-circle-close"></i>
                    <span >清除地区</span>
                </el-button> -->
            </div>

        </div>
        <!--排序-->
        <div class="sortClass">
            <!-- <div class="typeName">排序：</div> -->
            <ul>
                <li
                    v-for="(item, index) in sortList"
                    :class="activeSortIndex === index ? 'active' : ''"
                    @click="search(index)"
                    :key="index"
                >
                    {{ item.name }}
                    <i class="el-icon-bottom" v-if="index == 0 && activeSortIndex1 == 0"></i>
                    <i class="el-icon-top" v-if="index == 0 && activeSortIndex1 == 1"></i>
                    <i class="el-icon-bottom" v-if="index == 1 && activeSortIndex2 == 0"></i>
                    <i class="el-icon-top" v-if="index == 1 && activeSortIndex2 == 1"></i>
                    <i class="el-icon-bottom" v-if="index == 2 && activeSortIndex3 == 0"></i>
                    <i class="el-icon-top" v-if="index == 2 && activeSortIndex3 == 1"></i>
                </li>
            </ul>
        </div>
        <!-- 需求列表 -->
          <div v-if="showNoDesigner" style="text-align:center;margin-bottom:20px" >
                <img src="../../assets/暂无搜索内容.jpg" alt="" style="width:200px">
            </div>
        <div class="container" v-loading="loading" v-if="designPeo.length!=0">
            <div v-for="(items, index) in designPeo" :key="index">
                <div class="lookingMasterCard">
                    <div class="fMaster" >
                        <div class="lookingMasterCardLeft">
                            <div class="avatar" @click="getDesigner(items.uuid)" style="cursor: pointer;">
                                <img :src="!items.imgs ? require('../../assets/设计市场/'+(items.sex=='FEMALE'?'头像6.png':'头像1.jpeg')) : items.imgs"alt=""/>
                            </div>
                            <div class="fMasterInfo">
                                <p class="fMasterInfoName" @click="getDesigner(items.uuid)" style="cursor: pointer;">
                                    {{ items.name }}
                                    <img v-for="(item,index) in items.designerLevels" src="../../assets/模型库/designIcon.png" :src="item.levelIconUrl" title="" :title="item.name"
                                         style="width: 55px;height: 20px;margin-left: 5px;">
                                </p>
                                <p class="fMasterInfoAddr" style="font-size: 12px">
                                    <span>{{ items.provinces }} | {{ items.city }}</span>
                                </p>
                                <ul class="fMasterInfoAddr">
                                    <li class="infoItem">
                                        <span>作品</span><span class="num">{{ items.works }}</span>
                                    </li>
                                    <li class="infoLine">|</li>
                                    <li class="infoItem">
                                        <span>粉丝</span><span class="num">{{ items.fans }}</span>
                                    </li>
                                    <li class="infoLine">|</li>
                                    <li class="infoItem">
                                        <span>订单</span><span class="num">{{ items.order }}</span>
                                    </li>
                                    <!--<li class="infoLine">|</li>
                                    <li class="infoItem">-->
                    <!--<span>好评率</span-->
                    <!--&gt;<span class="num">{{ items.opinion }}</span>-->
                                    <!--</li>-->
                                </ul>
                                <div class="fMasterBtn" style="margin-top: 10px">
                                    <el-button type="text"  v-if="!items.hasLiked" @click="liked(items)">
                                        <i
                                                class="iconfont icon-aixin1"
                                        ></i>
                                        关注
                                    </el-button>
                                    <el-button type="text" v-if="items.hasLiked" @click="liked(items)">
                                        <i
                                                class="iconfont icon-aixin"
                                        ></i>
                                        已关注
                                    </el-button>
                                    <el-button type="text"  @click="startChat(items.userId)"
                                    ><i class="el-icon-message"></i>私信
                                    </el-button
                                    >
                                </div>
                            </div>
                        </div>
                        <div class="lookingMasterCardRight" v-if="items.imgsMess.length != 0">
                            <img
                                v-for="(imgItem, index) in items.imgsMess"
                                :key="index"
                                style="
                                    width: 216px;
                                    height: 162px;
                                    border-radius: 10px;
                                    margin-right: 10px;
                                "
                                :src="imgItem"
                                fit="fill"
                            />

                        </div>
                        <div class="lookingMasterCardRight" v-else>
                            <img
                                style="
                                    width: 216px;
                                    height: 162px;
                                    border-radius: 10px;
                                    margin-right: 10px;
                                "
                                src="../../assets/设计市场/default.jpg"
                            />
                        </div>
                        <!--<div class="dot"><i class="iconfont icon-gengduo1"></i></div>-->
                    </div>
                </div>
            </div>

			<div style="text-align: right; padding: 50px 0">
			    <el-pagination
			            @size-change="handleSizeChange"
			            @current-change="handleCurrentChange"
			            :current-page="current"
			            :page-sizes="[5, 10, 20, 50]"
			            layout="total, sizes, prev, pager, next, jumper"
			            :total="total">
			    </el-pagination>
			</div>
            </div>



      <!--聊天窗口-->
      <chat-dialog ref="chatDialogRef"></chat-dialog>
    </div>
</template>

<script>
import {getDictionaryItem, designerListByPage, like, getRongCloudUser,getDesignLevel} from "../../utils/interface";
    import {mapState, mapMutations} from "vuex";
    import provinceData from "../../utils/provinceData";
    import chatDialog from "../chat/chatDialog";

    export default {
        //   需求列表
        name: "designList",
        metaInfo: {
            title: '找大师 -设计市场- 提供企业、个人用户、设计师的供需对接服务-增材云', // set a title
            meta: [{                 // set meta
                name: 'keywords',
                content: '工业制造 | 汽车零部件 | 雕塑设计 | 家居 |文创 | 人像建模 | 仿真模型 | 建筑'
            },
                {
                    name:'description',
                    content: '增材云找大师设计服务，从设计师擅长领域、好评率、订单量出发，精选高品质3D建模设计师，为企业提供供需对接服务，在线定制出个性化的产品。'
                }
            ],
        },
        components: {provinceData, chatDialog },
        data() {
            return {
                showNoDesigner:false,
                keywords:[],
                form: {keyword:'',},
                loading: true,
                activeIndex: 0,
                activeSortIndex: '',
                current: 1,
                total: 0,
                pageSize:10,
                screenList: [
                    {
                        name: "全部",
                        // screenTwo: [
                        // ],
                    },
                    {
                        name: "",
                        // screenTwo: [
                        // ],
                    },
                    {
                        name: "",
                        // screenTwo: [
                        // ],
                    },
                ],
                printScreenIndex: "0",
                classShow: false,

                sortList: [
                    {
                        name: "作品",
                    },
                    {
                        name: "订单",
                    },
                    {
                        name: "粉丝",
                    },
                ],
                designPeo: [
                ],
                // 地区选择
                regionValue: [],
                regionOptions: provinceData,
                // 作品选择
                checkAll: false,
                checkedCities: [],
                isIndeterminate: true,
                checkedCountsleng: [],
                design: [],
                activeSortIndex1: 0,
                activeSortIndex2: 0,
                activeSortIndex3: 0,
            };
        },
        computed: {
            ...mapState({
                isTokenDoor: "isTokenDoor",
                isLogin: "isLogin",
            }),
        },
        mounted() {
        },
        created() {
            this.getDictionaryItem();
            this.search();
        },
        methods: {
            ...mapMutations(["isLoginVuex"]),
            // 地区选择
            handleChange(value) {
                if(value != null && value.length == 3){
                    this.form.province = value[0];
                    this.form.city = value[1];
                    this.form.district = value[2];
                    this.search();
                } else if(value != null && value.length == 2){
                    this.form.province = value[0];
                    this.form.city = value[1];
                    this.form.district = value[1];
                    this.search();
                }else{
                    this.regionValue = [];
                    this.form.province = null;
                    this.form.city = null;
                    this.form.district = null;
                    this.search();
                }
            },
            getPrintScreen(i) {
                if (this.printScreenIndex == i) {
                    this.classShow = !this.classShow;
                } else {
                    this.classShow = true;
                }
                this.printScreenIndex = i;
                if(i == 0){
                    this.form.type = '';
                }else if(i == 1){
                    this.form.type = 'MODEL';
                }else if(i == 2){
                    this.form.type = 'GRAPHIC';
                }
                this.search();
                // this.checkAll = true;
                // this.handleCheckAllChange(true);
            },
            // handleCheckAllChange(val) {
            //     this.checkedCities = val
            //         ? this.screenList[this.printScreenIndex].screenTwo
            //         : [];
            //     this.isIndeterminate = false;
            //     console.log(this.checkedCities);
            //     if(this.checkedCities.length > 0){
            //         let cates = [];
            //         this.checkedCities.forEach((item, index) => {
            //             cates.push(item.id);
            //         });
            //         let categories  = cates.join(",");
            //         this.form.cates = categories;
            //         this.search();
            //     }
            // },
            // handleCheckedCitiesChange(value) {
            //     this.checkedCountsleng = value;
            //     let checkedCount = this.checkedCountsleng.length;
            //     this.checkAll =
            //         checkedCount ===
            //         this.screenList[this.printScreenIndex].screenTwo.length;
            //     this.isIndeterminate =
            //         checkedCount > 0 &&
            //         checkedCount < this.screenList[this.printScreenIndex].screenTwo.length;
            //     console.log('----------------------'+JSON.stringify(value));
            //     if(value.length > 0){
            //         let cates = [];
            //         value.forEach((item, index) => {
            //             cates.push(item.id);
            //         });
            //         let categories  = cates.join(",");
            //         this.form.cates = categories;
            //         this.search();
            //     }
            // },
            // 获取字典值
            getDictionaryItem(){
                // let resource = [];
                getDictionaryItem({groupCode: 'graphic_designer'}).then((res)=>{
                    // let re = [];
                    if(res != null && res.length > 0){
                        this.screenList[2].name = res[0].groupName;
                        // res.forEach((item, index) => {
                        //     re.push({'names':item.name, 'id' : item.code, 'groupId': item.groupUuid});
                        //     resource.push({'names':item.name, 'id' : item.code, 'groupId': item.groupUuid});
                        // });
                        // this.screenList[2].screenTwo = re;
                    }
                    getDictionaryItem({groupCode: 'model_designer'}).then((res1)=>{
                        // let re = [];
                        if(res1 != null && res1.length > 0){
                            this.screenList[1].name = res1[0].groupName;
                            // res1.forEach((item, index) => {
                            //     re.push({'names':item.name, 'id' : item.code, 'groupId': item.groupUuid});
                            //     resource.push({'names':item.name, 'id' : item.code, 'groupId': item.groupUuid});
                            // });
                            // this.screenList[1].screenTwo = re;
                        }
                    });

                });
                // this.screenList[0].screenTwo = resource;
                // console.log(this.screenList)
                getDictionaryItem({groupCode: 'designer_keyword'}).then((res)=>{
                    // let re = [];
                    if(res != null && res.length > 0){
                        res.forEach((item, index) => {
                                this.keywords.push(item.name);
                            });
                    }
                });
            },
            getDesigner(uuid) {
                //this.$router.push("/designModel");
                let routeData = this.$router.resolve({
                    name: "designModel", params: {uuid: uuid}
                });
                window.open(routeData.href, "_blank");
            },
            search(index){
                if(index == 0 && this.activeSortIndex1 == 0){
                    this.form.sort = 'productionNum';
                    this.form.order = 'ASC';
                    this.activeSortIndex = 0;
                    this.activeSortIndex1 = 1;
                }else if(index == 0 && this.activeSortIndex1 == 1){
                    this.form.sort = 'productionNum';
                    this.form.order = 'DESC';
                    this.activeSortIndex = 0;
                    this.activeSortIndex1 = 0;
                }else if(index == 1 && this.activeSortIndex2 == 0){
                    this.form.sort = 'orderNum';
                    this.form.order = 'ASC';
                    this.activeSortIndex = 1;
                    this.activeSortIndex2 = 1;
                }else if(index == 1 && this.activeSortIndex2 == 1){
                    this.form.sort = 'orderNum';
                    this.form.order = 'DESC';
                    this.activeSortIndex = 1;
                    this.activeSortIndex2 = 0;
                }else if(index == 2 && this.activeSortIndex3 == 0){
                    this.form.sort = 'likeNum';
                    this.form.order = 'ASC';
                    this.activeSortIndex = 2;
                    this.activeSortIndex3 = 1;
                }else if(index == 2 && this.activeSortIndex3 == 1){
                    this.form.sort = 'likeNum';
                    this.form.order = 'DESC';
                    this.activeSortIndex = 2;
                    this.activeSortIndex3 = 0;
                }
                this.form.status =  "PASS";
                this.form.survival =  "ENABLE";
                this.form.current = this.current;
                this.form.pageSize = this.pageSize;
                if(this.isLogin){
                    this.form.isLogin = 1
                }else{
                    this.form.isLogin = 0
                }
                designerListByPage(this.form).then((res)=>{
                    this.designPeo = [];
                    if(res != null && res.list != null && res.list.length > 0){
                        this.showNoDesigner=false;
                        this.total = res.total;
                        res.list.forEach((item, index) => {
                            let designer = {};
                            designer.designerLevels = item.designerLevels;
                            designer.uuid = item.uuid;
                            designer.userId = item.userId;
                            designer.name = item.nickname;
                            designer.sex = item.sex;
                            designer.provinces = item.province;
                            designer.city = item.city;
                            designer.works = item.productionNum;
                            designer.fans = item.likeNum;
                            designer.order = item.totalOrderNum;
                            designer.opinion = "98%";
                            designer.introduction = item.introduction;
                            designer.imgs = item.iconUrl;
                            let imgUrl = [];
                            if(item.designerPassAttachmentList != null && item.designerPassAttachmentList.length > 0){
                                if(item.designerPassAttachmentList.length == 3){
                                    item.designerPassAttachmentList.forEach((item, index) => {
                                            imgUrl.push(item.fileUrl);
                                    });
                                }else if(item.designerPassAttachmentList.length == 2){
                                    item.designerPassAttachmentList.forEach((item, index) => {
                                        imgUrl.push(item.fileUrl);
                                    });
                                    console.log('imgUrl',imgUrl );
                                    imgUrl.push(require('../../assets/设计市场/default.jpg'));
                                }else if(item.designerPassAttachmentList.length == 1){
                                    item.designerPassAttachmentList.forEach((item, index) => {
                                        imgUrl.push(item.fileUrl);
                                    });

                                    imgUrl.push(require('../../assets/设计市场/default.jpg'));
                                    imgUrl.push(require('../../assets/设计市场/default.jpg'));
                                }else{

                                        item.designerPassAttachmentList.forEach((item, index) => {
                                            if(imgUrl.length < 3) {
                                                imgUrl.push(item.fileUrl);
                                            }
                                        });
                                }
                            }else{
                                imgUrl.push(require('../../assets/设计市场/default.jpg'));
                                imgUrl.push(require('../../assets/设计市场/default.jpg'));
                                imgUrl.push(require('../../assets/设计市场/default.jpg'));
                            }
                            designer.imgsMess = imgUrl;
                            designer.hasLiked = item.hasLiked;
                            // getDesignLevel({
                            //     designerUuid : designer.uuid
                            // }).then((res) => {
                            //     designer.designerLevelList = res;
                            // });
                            this.designPeo.push(designer);
                        });
                        this.loading = false
                    }else{
                        this.showNoDesigner=true;
                        this.total = 0;
                    }
                });
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.search();
            },
            handleCurrentChange(val) {
                this.current = val;
				window.scrollTo(0,0);
                this.search();
            },
            liked(designer) {
                if (this.isLogin) {
                    if(this.$store.state.isUsermessage.uuid == designer.userId){
                        this.$message({
                            type: "success",
                            message: "不能关注自己！",
                        });
                        return ;
                    }
                let params = {
                    likeType: 'DESIGNER',
                    serviceType: 'LIKE',
                    designerUuid: designer.uuid,
                };
                like(params).then((res) => {
                    if(res && res.success){
                        this.search();
                        this.$message({
                            type: "success",
                            message: res.message,
                        });
                    }
                });
            } else {
                this.$message({
                    type: "success",
                    message: "您需要先登录哦！",
                });
    this.$router.push('/login')
    }
            },
            // // 检索重置
            // reset(){
            //     this.regionValue = [];
            //     this.form.province = null;
            //     this.form.city =  null;
            //     this.form.district =  null;
            // },
          startChat(targetUserId) {
            if (this.isLogin) {
              let user = this.$store.state.isUsermessage;
              getRongCloudUser(targetUserId).then(res=> {
                this.$refs.chatDialogRef.init(user.uuid,user.name,user.headUrl,res.uuid,res.name,res.headUrl);
              });
            } else {
              this.$message({
                type: "success",
                message: "您需要先登录哦！",
              });
              this.$router.push('/login')
            }
          },
            searchByKeyword(keyword){
                this.form.keyword = keyword;
                this.search();
            },
        },
    };
</script>

<style scoped lang="less">
    .sortClass {
        width: 1200px;
        margin: 0 auto;
        padding: 18px 0;
        box-sizing: border-box;
        display: flex;
        flex-wrap: wrap;
        font-size: 14px;
        color: #262626;

        .typeName {
            padding: 5px 20px 5px 12px;
        }

        ul {
            display: flex;

            li {
                padding: 5px 12px;
                cursor: pointer;
                margin-right: 10px;
                background: #fff;

                &.active {
                    color: #fff;
                    background: #157efb;
                }
            }
        }
    }

    .printBanner {
        background: url("../../assets/image/fulist.png");
    }

    .destoPone {
        p {
            margin-bottom: 10px;
            margin-right: 0px;
            padding: 3px 14px;
            font-size: 14px;
        }

        .materDetailsT {
            // background: #157efb;
            color: #157efb;
            border-radius: 5px;
            padding: 3px 15px;
            margin-bottom: 10px;
        }
    }

    .lookingMasterCard {
        margin-bottom: 30px !important;
        background: #fff;
        border: 1px solid #f5f5f5;
        border-radius: 10px;
        box-sizing: border-box;

        .fMaster {
            display: flex;
            justify-content: space-between;
            position: relative;

            .dot {
                position: absolute;
                right: -5px;
                top: 52px;
                color: #338efb;

                i {
                    font-size: 20px;
                }
            }

            .lookingMasterCardLeft {
                display: flex;
                align-items: center;
                padding: 30px 20px 30px 30px;

                .avatar {
                    width: 100px;
                    height: 100px;
                    margin-right: 10px;

                    img {
                        border-radius: 100%;
                        width: 100%;
                        height: 100%;
                    }
                }

                .fMasterInfoName {
                    padding-top: 0;
                    font-size: 18px;
                    color: #333;
                    margin: 0;
                }

                .fMasterInfoAddr {
                    padding-top: 9px;
                    font-size: 14px;
                    color: #666;
                    display: flex;

                    li {
                        color: #000;

                        .num {
                            color: #157efb;
                            display: inline-block;
                            min-width: 35px;
                            text-align: center;
                            padding: 0 5px;
                            box-sizing: border-box;
                        }

                        &.infoLine {
                            padding-right: 11px;
                        }
                    }
                }
            }

            .lookingMasterCardRight {
                display: flex;
                padding: 10px;

                /deep/ .el-image:nth-of-type(3n) {
                    margin-right: 0 !important;
                }
            }
        }

        .fMasterDesc {
            margin: 0;
            padding: 10px 20px 0 20px;
            border-top: none;

            p {
                height: 60px;
                width: 100%;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
                line-height: 27px;
                color: #666;
            }
        }
    }

    .container {
        width: 1200px;
        margin: 0 auto;

        .bannerSearch {
            /deep/ .el-input__inner {
                height: 50px;
                line-height: 50px;
            }

            /deep/ .el-input-group__append {
                background-color: #157efb;
                color: #fff !important;
                font-size: 18px;
                border-color: transparent;
            }
        }
    }

    .desTitle {
        width: 1200px;
        margin: 21px auto 16px;
        align-items: center;

        span {
            color: #808080;
            font-size: 14px;
        }
    }

    .desClass {
        width: 1200px;
        margin: 0 auto;
        background: #fff;
        box-sizing: border-box;

        .desCommentClass {
            padding: 18px 28px;
            box-sizing: border-box;
            display: flex;
            flex-wrap: wrap;
            font-size: 14px;
            color: #262626;

            .typeName {
                padding: 5px 20px 5px 12px;
            }
        }

        .desBottomClass {
            .typeName {
                padding: 8px 20px 8px 12px;
            }
            .resetBtn {
                span {
                    margin-left: 10px;
                }
            }
        }

        .materDetailsT {
            margin-bottom: 10px;
            margin-right: 0px;
            padding: 3px 14px;
            font-size: 14px;
        }

        .desTopClass {
            border-bottom: 1px solid #ddd;

            .print_screen_boxP {
                display: flex;
                flex-wrap: wrap;

                p {
                    cursor: pointer;
                    margin-bottom: 10px;
                    margin-right: 0px;
                    padding: 3px 14px;
                    font-size: 14px;
                }

                .screen_text {
                    color: #157efb;
                    background: #157efb;
                    border-radius: 5px;
                    margin-bottom: 10px;
                    color: #fff;
                    padding: 3px 15px;
                    font-size: 14px;
                    cursor: pointer;
                }
            }

            ul {
                display: flex;

                li {
                    padding: 5px 12px;
                    cursor: pointer;
                    margin-right: 10px;

                    &.active {
                        color: #fff;
                        background: #157efb;
                        border-radius: 4px;
                    }
                }
            }
        }
    }

    .printTitle {
        color: #1f7de9;
        font-weight: bold;
        margin-top: 60px;
        margin-bottom: 15px;

        span.more {
            cursor: pointer;
            font-size: 14px;
            float: right;
            margin-top: 10px;
        }

        .more i {
            color: #505050 !important;
        }
    }

    .box-card {
        border: 1px solid #e3e3e3;
        margin-bottom: 30px;
    }

    .fMaster {
        display: flex;
        position: relative;

        /deep/ .el-avatar--96 {
            width: 80px;
            height: 80px;
        }
    }

    .fMasterInfo {
        flex: 1;
        margin-left: 10px;

        .fMasterInfoName {
              display: flex;
            align-items: center;
            margin-bottom: 10px;
        }

        .fMasterInfoAddr {
            font-size: 12px;
            color: #808080;
        }

        .fMasterInfoAddr i {
            margin-right: 5px;
        }

        .fMasterAna {
            font-size: 12px;
            margin: 20px 0;
        }

        .fMasterAna span.numBlue {
            color: #157efb;
            margin-left: 5px;
        }

        .fMasterBtn {
            /deep/ .el-button--text {
                color: #157efb;
                padding: 0;
            }

            button {
                margin-right: 30px;
            }

            font-size: 12px;

            i {
                font-size: 15px;
                padding-right: 5px;
            }
        }
    }

    .fMasterDesc {
        margin: 20px -20px 0;
        padding: 20px 20px 0;
        font-size: 14px;
        border-top: 1px solid #e3e3e3;
    }

    .rqTitle {
        font-size: 16px;
        font-weight: normal;
        color: rgba(0, 0, 0, 0.85);
        margin-bottom: 10px;
    }

    .rqPrice {
        font-size: 14px;
        color: #157efb;
        border: 1px solid #157efb;
        padding: 5px 20px 5px 70px;
        position: relative;
        width: fit-content;

        span.tagBlue {
            background-color: #157efb;
            color: #fff;
            font-size: 12px;
            width: 50px;
            position: absolute;
            left: 0;
            top: 0;
            bottom: 0;
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }

    .rqDetail {
        margin-top: 20px;

        dt {
            float: left;
            width: 70px;
            color: #000;
            font-size: 13px;
            font-weight: 400;
            text-align: left;
            line-height: 24px !important;
        }

        dd {
            color: #808080;
            font-size: 13px;
            line-height: 24px !important;
            margin-left: 80px;
            margin-bottom: 8px;
        }
    }

    .rqFooter {
        display: flex;
        justify-content: space-between;
        align-items: center;
        background: #f1f5fe;
        border: 1px solid #e3e3e3;
        margin: 0 -21px -21px;
        position: relative;

        span {
            cursor: pointer;
            display: inline-block;
            width: 50%;
            text-align: center;
            font-size: 13px;
            height: 50px;
            color: #157efb;

            line-height: 50px;
        }

        span a {
            color: #157efb;
        }

        span:hover {
            color: rgba(21, 126, 251, 0.8);
        }

        :after {
            position: absolute;
            content: "";
            width: 1px;
            background-color: #e3e3e3;
            height: 34px;
            top: 8px;
            left: 50%;
        }
    }
</style>
<style lang="less">
    .lookingMasterCard {
        .el-card__body {
            padding: 0;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/design/designerList.vue